import React, { Component } from "react";
import { Helmet } from "react-helmet";

function ThankYouUC() {
    return (
        <Helmet>
            <meta property="og:url" content="https://divivgroup.lpages.co/thank-you-uc/" />
            <link rel="opengraph" href="https://divivgroup.lpages.co/thank-you-uc/" />
            <script src="https://divivgroup.lpages.co/_/js/thank-you-uc/"></script>
            <style>{'html{font-family:"Roboto", sans-serif} strong { color: inherit; } section{ padding: 10px} a:hover{text-decoration:none} .css-1ml7zq4{background:#ffffff} #___gatsby, #gatsby-focus-wrapper{display:none}'}</style>
        </Helmet>
    )
}

export default ThankYouUC;